import { render, staticRenderFns } from "./plansOverview.vue?vue&type=template&id=ea71eeb8&lang=pug"
import script from "./plansOverview.vue?vue&type=script&lang=js"
export * from "./plansOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports